import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'

const MONTH_INDEXES = { Jan: 0, Apr: 3, Jul: 6, Oct: 9 }

export const periodTitle = (labelA: string, labelB: string) =>
  translate.phrases.templates('{{labelA}} ({{labelB}})', { labelA, labelB })

export const lastDays = (count: number) => translate.phrases.banyanApp('Last {{count}} Days', { count })

export const nextDays = (count: number) => translate.phrases.banyanApp('Next {{count}} Days', { count })

export const lastHours = (count: number) => translate.phrases.banyanApp('Last {{count}} Hours', { count })

export const nextHours = (count: number) => translate.phrases.banyanApp('Next {{count}} Hours', { count })

export const sinceFirstOf = (month: keyof typeof MONTH_INDEXES) =>
  translate.phrases.banyanApp('Since {{date}}', {
    date: translate.dates.format(moment.tz('UTC').month(MONTH_INDEXES[month]).date(1), 'MMM D'),
  })
